import { httpReducer } from "../lib/create-action";
import { setCurrentUserOnState } from "./user";
import { adminLoginAsActionPrefix } from "../actions/admin_login_as";
import get from "lodash/get";

export default httpReducer(
  adminLoginAsActionPrefix,
  {
    isLoading: false,
  },
  {
    success: (state, action) => {
      state = setCurrentUserOnState(state, {
        user: get(action, "payload.resp"),
      });
      return state;
    },
  }
);
